import { Link } from "react-router-dom";
import { popularAnime } from "@/mocks/animeData";

export default function PopularRanking() {
  const top10 = [...popularAnime].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100">
              人气排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              大家都在看的热门作品
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {top10.map((anime, index) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-800/60 hover:bg-background-700/60 border border-background-700/30 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                  index < 3
                    ? "bg-primary-500 text-background-950"
                    : "bg-background-700 text-foreground-500"
                }`}
              >
                {index + 1}
              </div>
              <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={anime.coverImage}
                  alt={anime.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors truncate">
                  {anime.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {anime.category} · {anime.episodes}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <span className="w-4 h-4 flex items-center justify-center text-accent-400">
                  <i className="ri-star-fill text-xs"></i>
                </span>
                <span className="text-sm font-bold text-accent-400">
                  {anime.rating}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}